import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email = new FormControl('', [Validators.required, Validators.email]);
  hide = true;
  userpassword: string;
  useremail: string;
  loginErrorMessage: string;
  dialogRef: MatDialogRef<LoginComponent>;

  constructor(public fauth: AngularFireAuth, public router: Router, public dialog: MatDialog) {
  }

  ngOnInit() {
  }

  login() {
    this.fauth.auth.signInWithEmailAndPassword(this.useremail, this.userpassword)
    .then(result => {
      console.log(result);
    })
    .catch(error => {
      this.loginErrorMessage = error.message;
    });
  }

  loginFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider();
    provider.addScope('email');
    firebase.auth().signInWithPopup(provider).then(a => {

    })
    .catch(e => {
      console.log(e);
    });
  }

  loginGithub() {
    const provider = new firebase.auth.GithubAuthProvider();
    provider.addScope('email');
    firebase.auth().signInWithPopup(provider).then(a => {

    })
    .catch(e => {

    });
  }

  loginGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then(a => {

    })
    .catch(e => {

    });
  }

  getErrorMessage() {
    return this.email.hasError('required') ? 'You must enter a value' :
      this.email.hasError('email') ? 'Not a valid email' :
        '';
  }

  loginTwitter() {
    const provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().signInWithPopup(provider).then(a => {

    })
    .catch(e => {

    });
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts